<template>
<div class="d-flex flex-row justify-content-between flex-wrap">
	<div>
		<i v-if="equipment.color_hex" class="fa fa-circle mr-1" :style="{color:equipment.color_hex}"></i>
		{{equipment.description}}
		<small>({{typeSelected.name}})</small>
	</div>

	<template v-if="!hideMeta">
		<div class="text-muted">{{equipment.serial_num}}</div>
		<div class="text-muted">
			<template v-if="equipment.next_service_date">

				{{equipment.next_service_description}} due {{formatDateTimeToLocal(equipment.next_service_date)}}/{{equipment.next_service_mileage_or_time}}
				
			</template>
		</div>
	</template>
	<div v-if="equipment.attachedData" v-html="equipment.attachedData"></div>
	<div>
		<i v-if="includeArchived && equipment.archived == 1" title="Archived" class="fa fa-archive"></i>
	</div>
</div>	
</template>

<script type="text/javascript">

export default {
	name: "EquipmentTileTemplate",
	props: [
		"equipment",
		"includeArchived",
		"typeSelected",
		"hideMeta"
	]
}

</script>